import { render, staticRenderFns } from "./CancelationPolicyDialog.vue?vue&type=template&id=2a7ca008&"
import script from "./CancelationPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./CancelationPolicyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports